/**
 * Copy rich HTML signature to clipboard (text/html + text/plain).
 * Falls back to execCommand when ClipboardItem is unavailable.
 */
export async function copySignatureHtml(html) {
  const container = document.createElement('div')
  container.innerHTML = html
  const text = container.innerText

  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      const blobHtml = new Blob([html], { type: 'text/html' })
      const blobText = new Blob([text], { type: 'text/plain' })
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': blobHtml,
          'text/plain': blobText,
        }),
      ])
      return
    } catch {
      // fall through to legacy copy
    }
  }

  const tempDiv = document.createElement('div')
  tempDiv.style.position = 'absolute'
  tempDiv.style.left = '-9999px'
  tempDiv.innerHTML = html
  document.body.appendChild(tempDiv)

  const range = document.createRange()
  range.selectNode(tempDiv)
  const selection = window.getSelection()
  selection?.removeAllRanges()
  selection?.addRange(range)

  const successful = document.execCommand('copy')
  selection?.removeAllRanges()
  document.body.removeChild(tempDiv)

  if (!successful) {
    throw new Error('COPY_FAILED')
  }
}
